export class RjscSSOLogOff {
    encryptedUserId:string;
    sSORPID:string;
    sSOSessionID:string;
}
